export type AppContextState = Readonly<{
  language: string;
}>;

export const appContextState: AppContextState = {
  language: "en"
};
